import { render, staticRenderFns } from "./Stdin.vue?vue&type=template&id=4f1dc641&"
import script from "./Stdin.vue?vue&type=script&lang=js&"
export * from "./Stdin.vue?vue&type=script&lang=js&"
import style0 from "./Stdin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports